export const LS_KEYS = {
  USER_ID: "user_id",
  IDR: "idr",
  LANG: "lang",
  NAME: "name",
  CURRENCY_CODE: "currency_code"
};

export const getLSValue = (key) => {
  return localStorage.getItem(key);
};

export const setLSValue = (key, value) => {
  localStorage.setItem(key, value);
};
